import {
  collection, getDocs,
  query, where,
} from 'firebase/firestore';
import { db } from '@/lib/firebase';
import { DRXError } from '@/lib/drx-error';
import { assertClientMayWriteCollection } from '@/lib/firestore-client-write-guard';
import type {
  IStripeCustomerRepository, CreateStripeCustomerData, GetStripeCustomerData,
} from './interfaces/stripe-customer.repository.interface';

export class StripeCustomerRepository implements IStripeCustomerRepository {
  private collectionName = 'stripeCustomers';

  async createStripeCustomer(_customerData: CreateStripeCustomerData): Promise<GetStripeCustomerData> {
    assertClientMayWriteCollection(this.collectionName, 'createStripeCustomer');
  }

  async getStripeCustomer(userId: string): Promise<GetStripeCustomerData | null> {
    try {
      const q = query(
        collection(db, this.collectionName),
        where('userId', '==', userId),
      );
      const snapshot = await getDocs(q);
      return snapshot.empty
        ? null
        : { id: snapshot.docs[0].id, ...snapshot.docs[0].data() } as GetStripeCustomerData;
    } catch (error) {
      throw new DRXError({
        code: 'STRIPE_CUSTOMER_FETCH_FAILED',
        devMessage: `Failed to fetch Stripe customer for user ${userId}`,
        cause: error,
      });
    }
  }
}
